import { WORK_ORDER_CATEGORY_OPTIONS } from '../../work_order/categoryOptions';
import { TASK_TYPE_OPTIONS } from '../../work_order/taskTypeOptions';

export const taskerKey = a => `${a.type}:${a.id}`;
export const serviceOptions = (templates = []) => [
  ...TASK_TYPE_OPTIONS.filter(t=>t.value && t.value!=='all').map(t=>({value:`department:${t.value}`,label:t.label,group:'Task types'})),
  ...WORK_ORDER_CATEGORY_OPTIONS.map(t=>({value:`category:${t.value}`,label:t.label,group:'Specialist services (task category)'})),
  ...templates.map(t=>({value:`template:${t.id}`,label:t.name,group:'Checklist exceptions'})),
];
export const freshChanges = () => [{service_key:'department:cleaning',mode:'replace',assignees:[]}];
export const filterProperties = (catalog,filters) => {
  const {search='',property='',tag='',group='',tasker='',coverage='',service=''} = filters;
  const grouped = catalog.groups.find(g=>String(g.id)===String(group));
  return catalog.properties.filter(p => {
    const defs = catalog.defaults.filter(d=>String(d.rental_id)===String(p.rental_id));
    const hasDefault = defs.some(d=>(!service||d.service_key===service)&&d.assignees.length);
    return `${p.pms_id || ''} ${p.name || ''} ${p.address || ''}`.toLowerCase().includes(search.toLowerCase()) &&
      (!property || String(p.rental_id)===String(property)) &&
      (!tag || p.tags.some(t=>String(t.id)===String(tag))) &&
      (!grouped || p.tags.some(t=>grouped.tag_ids.map(String).includes(String(t.id)))) &&
      (!tasker || defs.some(d=>d.assignees.some(a=>taskerKey(a)===tasker))) &&
      (!coverage || (coverage==='missing' ? !hasDefault : hasDefault));
  });
};
export const EMPTY_CATALOG = {properties:[],defaults:[],taskers:[],templates:[],groups:[]};

export const PROPERTY_SORT_OPTIONS = [
  {key:'property',title:'Property'},
  {key:'updated_at',title:'Last Updated At'},
  {key:'cleaning',title:'Cleaning'},
  {key:'inspection',title:'Inspection'},
  {key:'maintenance',title:'Maintenance'},
  {key:'specialists',title:'Specialists'},
];
const regularServices = new Set(['department:cleaning','department:inspection','department:maintenance']);
const compareText = (a,b) => a.localeCompare(b,undefined,{numeric:true,sensitivity:'base'});
export const sortProperties = (properties,catalog,key='property') => {
  const byProperty=new Map(), taskers=new Map(catalog.taskers.map(a=>[taskerKey(a),a.name]));
  catalog.defaults.forEach(row=>{const id=String(row.rental_id);if(!byProperty.has(id))byProperty.set(id,[]);byProperty.get(id).push(row);});
  const value = property => {
    const rows=byProperty.get(String(property.rental_id))||[];
    if(key==='property')return property.pms_id||'';
    if(key==='updated_at')return Math.max(0,...rows.map(row=>Date.parse(row.updated_at)||0));
    return rows.filter(row=>key==='specialists'?!regularServices.has(row.service_key):row.service_key===`department:${key}`)
      .flatMap(row=>row.assignees.map(a=>taskers.get(taskerKey(a))||`Unavailable ${a.type} #${a.id}`)).sort(compareText).join(', ');
  };
  const values=new Map(properties.map(property=>[property,value(property)]));
  return [...properties].sort((a,b)=>{
    const av=values.get(a),bv=values.get(b);
    const order=key==='updated_at'?bv-av:(!av!==!bv?(av?-1:1):compareText(av,bv));
    return order||compareText(a.pms_id||'',b.pms_id||'')||Number(a.rental_id)-Number(b.rental_id);
  });
};

export const changesForTasker = a => [{service_key:`department:${a.category==='housekeeper'?'cleaning':a.category==='maintenance'?'maintenance':'other'}`,mode:'replace',assignees:[{type:a.type,id:Number(a.id)}]}];
